import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { forgotPasswordApi } from "../../../../utils/apis/auth-service";

export const useForgotPassword = () => {
    const navigate = useNavigate()
    const [emailErrorText, setEmailErrorText] = useState("")
    const [isLoading, setIsLoading] = useState(false)

    const onBackButtonClick = async () => {
        navigate("/login")
    }

    const handleInputSubmit = async (inputData: { [key: string]: string }) => {
        const email = inputData.email
        callForgotPassword(email)
    }

    const callForgotPassword = (email: string) => {
        setEmailErrorText("")
        setIsLoading(true)
        forgotPasswordApi(
            email,
            async () => {
                setIsLoading(false)
                navigate("/forgot-password-insert-code", { state: { email } })
            },
            async (error) => {
                setIsLoading(false)
                setEmailErrorText(error)
            }
        )
    }

    return {
        onBackButtonClick,
        emailErrorText,
        isLoading,
        handleInputSubmit,
    }
}